import React from "react";

const items = [
  { value: "35M", label: "Safe Man-Hours" },
  { value: "0", label: "Lost Time Injuries" },
  { value: "17+", label: "Years of Practice" },
  { value: "24", label: "Fortune-500 EHS Awards" },
  { value: "200+", label: "Training Sessions / Yr" },
  { value: "50+", label: "Concurrent Projects" },
];

export default function MetricsBand() {
  return (
    <section
      data-testid="metrics-band"
      id="track-record"
      className="dark-section bg-bgdark text-white border-y border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 border-b border-white/10">
        <p className="mono-label">By the numbers — Audit-grade record</p>
      </div>
      <div
        data-testid="metrics-container"
        className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6"
      >
        {items.map((item, i) => (
          <div
            key={item.label}
            data-testid={`metric-item-${i}`}
            className="px-6 lg:px-8 py-10 border-r border-b border-white/10 last:border-r-0 group hover:bg-white/[0.03] transition-colors"
          >
            <div className="font-mono text-4xl lg:text-5xl text-accent-amber tracking-tight">
              {item.value}
            </div>
            <div className="mt-3 text-[11px] uppercase tracking-[0.2em] text-white/60">
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
